import { Vue, prop } from 'vue-class-component';
import { Skeleton } from '@/components/skeleton/component';
import { Watch } from 'vue-property-decorator';
import clsx from 'clsx';
import styles from './styles.module.scss';

export interface TileObject {
	id: string;
	title: string;
	description?: string;
}

interface SkeletonOptions {
	description?: boolean;
	count: number;
}

class TileSelectorProps {
	tiles = prop<TileObject[]>({ default: undefined })

	skeletonOptions = prop<SkeletonOptions>({ default: { description: true, count: 6 } })

	active = prop<string>({ default: undefined })

	onChange = prop<Function>({ default: () => () => undefined })

	fullWidth = prop<boolean>({ default: false })
}

export class TileSelector extends Vue.with(TileSelectorProps) {
	selectedId = this.active || null;

	get items() {
		return this.tiles?.length ? this.tiles : (new Array(this.skeletonOptions.count)).fill({});
	}

	handleClick(id: string) {
		if (id === this.selectedId) { return; }
		this.selectedId = id;
		this.onChange(this.selectedId);
	}

	@Watch('active')
	updateActive(value: string) {
		if (value === this.selectedId) { return; }
		this.selectedId = value;
	}

	render() {
		return (
			<div class={ styles.tileSelector }>
				{ this.items.map(({ id, title, description }) => (
					<div
						class={ clsx(
							styles.tileSelectorItem,
							id === this.selectedId && styles.tileSelectorItemActive,
							this.fullWidth && styles.tileSelectorItemFullWidth
						) }
						onClick={ () => this.handleClick(id) }>
						<div class={ styles.tileSelectorItemTitle }>
							{ title || <Skeleton /> }
						</div>
						{ (this.skeletonOptions.description || description) && <div class={ styles.tileSelectorItemDescription }>
							{ description || <Skeleton /> }
						</div> }
					</div>
				))}
			</div>
		);
	}
}
